/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import get from 'lodash/get';

import * as types from '../constants/ActionTypes';

export const tenantReducer = (state = {}, action) => {
  switch (action.type) {
    case types.SET_TENANT:
    case types.UPDATE_TENANT:
      return {
        ...state,
        ...action.payload,
      };
    case types.GET_TENANT_ACTIVE_SERVICES:
      return {
        ...state,
        fetchingData: true,
      };
    case types.GET_TENANT_ACTIVE_SERVICES_SUCCESS:
      return {
        ...state,
        fetchingData: false,
        services: action.payload,
      };
    case types.GET_TENANT_ACTIVE_SERVICES_FAILURE:
      return {
        ...state,
        fetchingData: false,
        error: action.error,
      };
    default:
      return state;
  }
};

// Selectors

export const getTenant = state => state.tenant;

export const getActiveServices = state => state.tenant.services;

export const isServiceActive = (state, service) =>
  get(state, ['tenant', 'services', service, 'isActive']) || false;
